import { DialogRef } from '@angular/cdk/dialog';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RESULTPAGEMESSAGE } from '@common/constants';
import { IResultPageState } from '@common/models';
import { ResultPageService } from '@common/services';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { PreLoginResultService } from './services/pre-login-result-page.service';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-pre-login-result-page',
  templateUrl: './pre-login-result-page.component.html',
  styleUrls: ['./pre-login-result-page.component.scss'],
})
export class PreLoginResultPageComponent implements OnInit {
  protected resultstate: Partial<IResultPageState> = {};
  isFavorite: boolean;
  currentFavInvNo: any;
  data:any;


  constructor(
    private _router: Router,
    private _preLoginResultService: PreLoginResultService,
    private _commonService: CommonService,
    private translate: TranslateService,
    private _matDialogRef: MatDialogRef<PreLoginResultPageComponent>
    
  ) {
    if(!this.data?.screenData) this.resultstate = this._router.getCurrentNavigation()?.extras?.queryParams
  }

  ngOnInit(): void {
    this._commonService.hideSpinner();
    if(this.data?.screenData) {
      this.resultstate = this.data.screenData.resultPageData;
    }
    if(this.resultstate.alertType === 'Success'){
      let resultMessage = this.translate.instant('RESULTPAGEMESSAGE.' + this.resultstate.serviceCode);
      this.resultstate.message = resultMessage;
    };
    this._preLoginResultService.resetResultPageData();
    document.body.classList.add('app-pre-login-result-page');
  }

  resultButtonClickHandler(navDetails): void {
    try {
      if(this._matDialogRef && Object?.keys(this._matDialogRef)?.length != 0){
        this._matDialogRef?.close();
      }
      this._router.navigate(navDetails.path, {
        queryParams: navDetails.state,
        queryParamsHandling: 'preserve',
      });
    } catch (err) {
      console.error(err);
    }
  }
  ngDestroy() {
    document.body.classList.remove('app-pre-login-result-page');
  }
  
}
